<template>
  <div class="space-for-navbar">
    <div class="container w-90">
      <div class="centered-on-page">
        <div class="row">
          <div class="col-sm-3">
            <h1>BMG Members Login</h1>
          </div>
          <div class="col-sm">
            <form
              id="loginForm"
              @submit.prevent="submit"
              action=""
              method="post"
              novalidate="true"
            >
              <div class="md-form md-bg">
                <font-awesome-icon
                  icon="envelope"
                  size="2x"
                  class="text-dark prefix"
                />
                <input
                  type="text"
                  id="emailInput"
                  class="form-control"
                  :class="{'is-invalid': $v.email.$invalid, 'is-valid': !$v.email.$invalid}"
                  v-model.trim="email"
                  @input="setEmail($event.target.value)"
                >
                <label
                  for="emailInput"
                  v-if="!this.hideEmailHelp"
                >E-mail address</label>
              </div>
              <div class="md-form">
                <font-awesome-icon
                  icon="key"
                  size="2x"
                  class="text-primary prefix"
                />
                <input
                  type="password"
                  id="passwordInput"
                  class="form-control"
                  :class="{'is-invalid': $v.password.$invalid, 'is-valid': !$v.password.$invalid}"
                  v-model.trim="password"
                  @input="setPassword($event.target.value)"
                >
                <label
                  for="passwordInput"
                  v-if="!this.hidePasswordHelp"
                >BMG Password</label>
              </div>
              <button
                class="bmg-btn-white-outline"
                :disabled="submitStatus === 'PENDING' || $v.email.$invalid || $v.password.$invalid"
              >
                Login
              </button>
              <div class="h3">
                <p
                  class="text-success"
                  v-if="submitStatus === 'OK'"
                >
                  Welcome! You should be rerouted shortly!
                </p>
                <p
                  class="text-danger"
                  v-if="submitStatus === 'ERROR'"
                >
                  {{ bigErrorMessage }}
                </p>
                <p
                  class="text-warning"
                  v-if="submitStatus === 'PENDING'"
                >
                  Sending...
                </p>
              </div>
            </form>
          </div>
        </div>
        <!-- END row -->
      </div>
    </div>
  </div>
</template>

<script>
import SecurityCheckMixin from './mixins/SecurityCheckMixin'
import { validationMixin } from 'vuelidate'
import { required, minLength, email } from 'vuelidate/lib/validators'

var emailRE = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export default {
  name: 'Login',
  mixins: [SecurityCheckMixin, validationMixin],
  props: [],
  data () {
    return {
      email: '',
      password: '',
      submitStatus: null,
      hideEmailHelp: false,
      hidePasswordHelp: false,
      bigErrorMessage: ''
    }
  },
  validations: {
    email: {
      required,
      minLength: minLength(6),
      email
    },
    password: {
      required,
      minLength: minLength(6)
    }
  },
  methods: {
    setEmail: function (value) {
      this.email = value
      this.$v.email.$touch()
      if (0 < this.email.length) {
        this.hideEmailHelp = true
      } else {
        this.hideEmailHelp = false
      }
    },
    setPassword: function (value) {
      this.password = value
      this.$v.password.$touch()
      if (0 < this.password.length) {
        this.hidePasswordHelp = true
      } else {
        this.hidePasswordHelp = false
      }
    },
    submit: function () {
      console.log('Checking the user in Firebase...')
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        // do your submit logic here
        this.submitStatus = 'PENDING'
        // var result = this.$root.doLogin(this.email, this.password)
        this.$root.logIn(this.email, this.password)
        .then(function (result) {
          console.log('Login Result: ', result)
          this.submitStatus = 'OK'
          this.$router.push({name: 'Home', params: { section: 'top' }})
        }.bind(this)).catch(function (error) {
          console.error('Login.submit(): Caught Error:', error)
          this.submitStatus = 'ERROR'
          this.bigErrorMessage = error.message + ' Revise your entry and try again, or contact Aaron Patty at 269.419.6376 for help.'
        }.bind(this))
      }
    }
  },
  components: {},
  computed: {},
  beforeMount () {},
  mounted () {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
